export const HEAD = [
  // ── Echo Items (stats TBD) ─────────────────────────────────────────────────
  {
    name: 'Echo Helm',
    echo: true,
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ──────────────────────────────────────────────────────────────────────────
  {
    name: 'Torva Full Helm',
    slot: 'head',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -5, ranged: -5 },
      defence: { stab: 59, slash: 60, crush: 62, magic: -2, ranged: 57 },
      other:   { meleeStrength: 8, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Justiciar Faceguard',
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -2 },
      defence: { stab: 60, slash: 63, crush: 59, magic: -6, ranged: 67 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Virtus Mask',
    slot: 'head',
    regions: ['Varlamore', 'Asgarnia', 'Fremennik', 'Desert'],
    requirements: [{ skill: 'Magic', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 8, ranged: -3 },
      defence: { stab: 15, slash: 14, crush: 16, magic: 6, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 2, prayer: 1 },
    },
  },
  {
    name: 'Masori Mask (f)',
    slot: 'head',
    regions: ['Desert', 'Asgarnia'],
    requireAllRegions: true,
    requirements: [{ skill: 'Ranged', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -1, ranged: 12 },
      defence: { stab: 8, slash: 10, crush: 12, magic: 12, ranged: 9 },
      other:   { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Ancestral Hat',
    slot: 'head',
    regions: ['Kourend'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 8, ranged: -2 },
      defence: { stab: 12, slash: 11, crush: 13, magic: 5, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 3, prayer: 0 },
    },
  },
  {
    name: 'Neitiznot Faceguard',
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 36, slash: 34, crush: 38, magic: 3, ranged: 34 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: "Inquisitor's Great Helm",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: -2, slash: -2, crush: 8, magic: -5, ranged: -5 },
      defence: { stab: 19, slash: 10, crush: 21, magic: 0, ranged: 12 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Serpentine Helm',
    slot: 'head',
    regions: ['Tirannwn'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -5, ranged: -5 },
      defence: { stab: 52, slash: 55, crush: 58, magic: 0, ranged: 50 },
      other:   { meleeStrength: 5, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Dharok's Helm",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -3, ranged: -1 },
      defence: { stab: 45, slash: 48, crush: 44, magic: -1, ranged: 51 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon Full Helm',
    slot: 'head',
    regions: ['Kandarin'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -3 },
      defence: { stab: 45, slash: 48, crush: 41, magic: -1, ranged: 46 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Slayer Helmet (i)',
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 3, ranged: 3 },
      defence: { stab: 30, slash: 32, crush: 27, magic: 10, ranged: 30 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Helm of Neitiznot',
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 31, slash: 29, crush: 34, magic: 3, ranged: 30 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: 'Obsidian Helmet',
    slot: 'head',
    regions: ['Karamja'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 25, slash: 23, crush: 26, magic: 0, ranged: 24 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Berserker Helm',
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 45 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -5, ranged: -5 },
      defence: { stab: 31, slash: 29, crush: 33, magic: 0, ranged: 30 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Barrows helms (Morytania) ─────────────────────────────────────────────
  {
    name: "Karil's Coif",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Ranged', level: 70 }, { skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -1, ranged: 7 },
      defence: { stab: 6, slash: 9, crush: 12, magic: 6, ranged: 10 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Ahrim's Hood",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Magic', level: 70 }, { skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 6, ranged: -2 },
      defence: { stab: 15, slash: 13, crush: 16, magic: 6, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: "Verac's Helm",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -2 },
      defence: { stab: 55, slash: 58, crush: 54, magic: 0, ranged: 56 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
  },
  {
    name: "Torag's Helm",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -2 },
      defence: { stab: 55, slash: 58, crush: 54, magic: -1, ranged: 62 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Guthan's Helm",
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -2 },
      defence: { stab: 55, slash: 58, crush: 54, magic: -1, ranged: 62 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Fremennik helms ────────────────────────────────────────────────────────
  {
    name: 'Warrior Helm',
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 45 }],
    bonuses: {
      attack:  { stab: 0, slash: 5, crush: 0, magic: -5, ranged: -5 },
      defence: { stab: 31, slash: 33, crush: 29, magic: 0, ranged: 30 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Archer Helm',
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Ranged', level: 45 }],
    bonuses: {
      attack:  { stab: -5, slash: -5, crush: -5, magic: -5, ranged: 6 },
      defence: { stab: 6, slash: 8, crush: 10, magic: 6, ranged: 6 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Farseer Helm',
    slot: 'head',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Magic', level: 45 }],
    bonuses: {
      attack:  { stab: -5, slash: -5, crush: -5, magic: 6, ranged: -5 },
      defence: { stab: 8, slash: 10, crush: 12, magic: 6, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Other region helms ─────────────────────────────────────────────────────
  {
    name: 'Robin Hood Hat',
    slot: 'head',
    regions: ['Kandarin'],
    requirements: [{ skill: 'Ranged', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 8 },
      defence: { stab: 4, slash: 6, crush: 8, magic: 4, ranged: 4 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Blue Moon Helm',
    slot: 'head',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Magic', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 6, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 10, magic: 6, ranged: 0 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: 'Blood Moon Helm',
    slot: 'head',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Strength', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -2 },
      defence: { stab: 20, slash: 31, crush: 34, magic: 7, ranged: 29 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Eclipse Moon Helm',
    slot: 'head',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: 8 },
      defence: { stab: 2, slash: 3, crush: 14, magic: 10, ranged: 4 },
      other:   { meleeStrength: 3, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Hueycoatl Hide Coif',
    slot: 'head',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 70 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -1, ranged: 7 },
      defence: { stab: 4, slash: 7, crush: 10, magic: 5, ranged: 8 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Crystal Helm',
    slot: 'head',
    regions: ['Tirannwn'],
    requirements: [{ skill: 'Defence', level: 70 }, { skill: 'Agility', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 9 },
      defence: { stab: 12, slash: 8, crush: 14, magic: 10, ranged: 18 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Masori Mask',
    slot: 'head',
    regions: ['Desert'],
    requirements: [{ skill: 'Ranged', level: 80 }, { skill: 'Defence', level: 30 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -1, ranged: 12 },
      defence: { stab: 3, slash: 4, crush: 3, magic: 6, ranged: 4 },
      other:   { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Sunfire Fanatic Helm',
    slot: 'head',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Defence', level: 40 }, { skill: 'Prayer', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -3 },
      defence: { stab: 30, slash: 32, crush: 27, magic: -1, ranged: 30 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 6 },
    },
  },
  {
    name: 'Proselyte Sallet',
    slot: 'head',
    regions: [],
    requirements: [{ skill: 'Defence', level: 30 }, { skill: 'Prayer', level: 20 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -6, ranged: -3 },
      defence: { stab: 19, slash: 21, crush: 16, magic: -1, ranged: 19 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 4 },
    },
  },
  {
    name: 'Black Mask (i)',
    slot: 'head',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 9, slash: 10, crush: 8, magic: -1, ranged: 9 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Void helms (universal) ─────────────────────────────────────────────────
  {
    name: 'Void Mage Helm',
    slot: 'head',
    regions: [],
    requirements: [{ skill: 'Attack', level: 40 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 6, slash: 6, crush: 6, magic: 6, ranged: 6 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
    sets: ['elite_void_mage'],
  },
  {
    name: 'Void Ranger Helm',
    slot: 'head',
    regions: [],
    requirements: [{ skill: 'Attack', level: 40 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 6, slash: 6, crush: 6, magic: 6, ranged: 6 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
    sets: ['elite_void_range'],
  },
  {
    name: 'Void Melee Helm',
    slot: 'head',
    regions: [],
    requirements: [{ skill: 'Attack', level: 40 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 6, slash: 6, crush: 6, magic: 6, ranged: 6 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
    sets: ['elite_void_melee'],
  },
  {
    name: "Oathplate helm",
    slot: 'head',
    regions: ['Kourend'],
    requirements: [{ skill: 'Defence', level: 78 }],
    bonuses: {
      attack:  { stab: 0, slash: 10, crush: 0, magic: -2, ranged: -7 },
      defence: { stab: 50, slash: 72, crush: 45, magic: 0, ranged: 50 },
      other:   { meleeStrength: 6, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
];
